import { render, staticRenderFns } from "./ModalSelecaoCaracteristicas.vue?vue&type=template&id=4d8da90a&scoped=true&"
import script from "./ModalSelecaoCaracteristicas.vue?vue&type=script&lang=js&"
export * from "./ModalSelecaoCaracteristicas.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelecaoCaracteristicas.vue?vue&type=style&index=0&id=4d8da90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8da90a",
  null
  
)

export default component.exports